// Utility functions for filtering data based on weather conditions

export const filterByWeatherConditions = (data, filters) => {
  if (!data || !filters) return data;

  return data.filter(item => {
    // Location filter (case-insensitive partial match)
    if (filters.location !== '' && filters.location !== undefined && filters.location !== null) {
      const searchLocation = filters.location.toLowerCase();
      const itemLocation = item.location?.toLowerCase() || '';
      if (!itemLocation.includes(searchLocation)) return false;
    }

    // Temperature range filters
    if (filters.snow_temp_min !== '' && item.snow_temperature_c !== null && item.snow_temperature_c !== undefined) {
      if (item.snow_temperature_c < parseFloat(filters.snow_temp_min)) return false;
    }
    if (filters.snow_temp_max !== '' && item.snow_temperature_c !== null && item.snow_temperature_c !== undefined) {
      if (item.snow_temperature_c > parseFloat(filters.snow_temp_max)) return false;
    }
    if (filters.air_temp_min !== '' && item.air_temperature_c !== null && item.air_temperature_c !== undefined) {
      if (item.air_temperature_c < parseFloat(filters.air_temp_min)) return false;
    }
    if (filters.air_temp_max !== '' && item.air_temperature_c !== null && item.air_temperature_c !== undefined) {
      if (item.air_temperature_c > parseFloat(filters.air_temp_max)) return false;
    }

    // Humidity range filters
    if (filters.snow_humidity_min !== '' && item.snow_humidity_doser !== null && item.snow_humidity_doser !== undefined) {
      if (item.snow_humidity_doser < parseFloat(filters.snow_humidity_min)) return false;
    }
    if (filters.snow_humidity_max !== '' && item.snow_humidity_doser !== null && item.snow_humidity_doser !== undefined) {
      if (item.snow_humidity_doser > parseFloat(filters.snow_humidity_max)) return false;
    }
    if (filters.air_humidity_min !== '' && item.air_humidity_rh !== null && item.air_humidity_rh !== undefined) {
      if (item.air_humidity_rh < parseFloat(filters.air_humidity_min)) return false;
    }
    if (filters.air_humidity_max !== '' && item.air_humidity_rh !== null && item.air_humidity_rh !== undefined) {
      if (item.air_humidity_rh > parseFloat(filters.air_humidity_max)) return false;
    }

    // Clouds range filter
    if (filters.clouds_min !== '' && item.clouds_sky_parts !== null && item.clouds_sky_parts !== undefined) {
      if (item.clouds_sky_parts < parseFloat(filters.clouds_min)) return false;
    }
    if (filters.clouds_max !== '' && item.clouds_sky_parts !== null && item.clouds_sky_parts !== undefined) {
      if (item.clouds_sky_parts > parseFloat(filters.clouds_max)) return false;
    }

    // Exact match filters
    if (filters.visibility !== '' && item.visibility !== filters.visibility) return false;
    if (filters.wind !== '' && item.wind !== filters.wind) return false;
    if (filters.precipitation !== '' && item.precipitation !== filters.precipitation) return false;
    if (filters.artificial_snow !== '' && item.artificial_snow !== filters.artificial_snow) return false;
    if (filters.natural_snow !== '' && item.natural_snow !== filters.natural_snow) return false;
    if (filters.grain_size !== '' && item.grain_size !== filters.grain_size) return false;
    if (filters.snow_humidity !== '' && item.snow_humidity !== filters.snow_humidity) return false;
    if (filters.track_hardness !== '' && item.track_hardness !== filters.track_hardness) return false;
    if (filters.track_shininess !== '' && item.track_shininess !== filters.track_shininess) return false;
    if (filters.track_dirtiness !== '' && item.track_dirtiness !== filters.track_dirtiness) return false;

    return true;
  });
};

export const getWeatherFilterSummary = (filters) => {
  const activeFilters = [];
  
  // Temperature ranges
  if (filters.snow_temp_min !== '' || filters.snow_temp_max !== '') {
    const min = filters.snow_temp_min || 'any';
    const max = filters.snow_temp_max || 'any';
    activeFilters.push(`Snow temp: ${min}°C - ${max}°C`);
  }
  if (filters.air_temp_min !== '' || filters.air_temp_max !== '') {
    const min = filters.air_temp_min || 'any';
    const max = filters.air_temp_max || 'any';
    activeFilters.push(`Air temp: ${min}°C - ${max}°C`);
  }

  // Humidity ranges
  if (filters.snow_humidity_min !== '' || filters.snow_humidity_max !== '') {
    const min = filters.snow_humidity_min || 'any';
    const max = filters.snow_humidity_max || 'any';
    activeFilters.push(`Snow humidity: ${min} - ${max}`);
  }
  if (filters.air_humidity_min !== '' || filters.air_humidity_max !== '') {
    const min = filters.air_humidity_min || 'any';
    const max = filters.air_humidity_max || 'any';
    activeFilters.push(`Air humidity: ${min}% - ${max}%`);
  }

  // Clouds range
  if (filters.clouds_min !== '' || filters.clouds_max !== '') {
    const min = filters.clouds_min || '0';
    const max = filters.clouds_max || '10';
    activeFilters.push(`Clouds: ${min}/10 - ${max}/10`);
  }

  // Exact matches
  const exactFilters = [
    { key: 'visibility', label: 'Visibility' },
    { key: 'wind', label: 'Wind' },
    { key: 'precipitation', label: 'Precipitation' },
    { key: 'artificial_snow', label: 'Artificial Snow' },
    { key: 'natural_snow', label: 'Natural Snow' },
    { key: 'grain_size', label: 'Grain Size' },
    { key: 'snow_humidity', label: 'Snow Humidity' },
    { key: 'track_hardness', label: 'Track Hardness' },
    { key: 'track_shininess', label: 'Track Shininess' },
    { key: 'track_dirtiness', label: 'Track Dirtiness' }
  ];

  exactFilters.forEach(filter => {
    if (filters[filter.key] !== '') {
      activeFilters.push(`${filter.label}: ${filters[filter.key]}`);
    }
  });

  return activeFilters;
};

export const hasActiveWeatherFilters = (filters) => {
  return Object.values(filters).some(value => value !== '');
};
